import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import {
  pageResetMiddleWare,
  zodOptionalDateRange,
  zodOptionalIdArray,
  zodPage,
} from 'routes/routeUtils';
import { z } from 'zod';

const labClaimsStatusSchema = z.enum(['transmitted', 'pending', 'closed_by_lab']);

export const labClaimsSearchSchema = z.object({
  status: z.tuple([labClaimsStatusSchema], labClaimsStatusSchema).optional(),
  pharmacyIds: zodOptionalIdArray,
  groupIds: zodOptionalIdArray,
  salesRepIds: zodOptionalIdArray,
  regionalDirectorIds: zodOptionalIdArray,
  createdAtRange: zodOptionalDateRange,
  query: z.string().optional(),
  tab: z.enum(['transmitted', 'pending', 'closed_by_lab', 'all']).default('all'),
  page: zodPage,
});

export type LabClaimsSearchType = z.infer<typeof labClaimsSearchSchema>;

export const labClaimsRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/claims/list',
  validateSearch: labClaimsSearchSchema,
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() => import('pages/lab/Claims/LabClaimsPage/LabClaimsPage').then((d) => d.Route));
